import * as angular from 'angular';

import { ToastService } from '@mode/shared/util-toast';

export class CopyToClipboardFieldController {
  private clipboardIsEnabled = false;
  private inputContent: string;
  private inputIsEnabled: boolean;
  private inputIsPassword: boolean;

  static $inject = ['ToastService'];

  constructor(private alertService: ToastService) {}

  public getContent(): string {
    return this.inputContent;
  }

  public getDisplayContent(): string {
    if (this.inputIsPassword) {
      // obfuscate value by displaying 12 dots (https://www.codetable.net/decimal/9679)
      return Array(13).join('&#9679;');
    }

    return this.getContent();
  }

  public isDisabled(): boolean {
    return !this.inputIsEnabled;
  }

  public inputType(): string {
    if (this.inputIsPassword) {
      return 'password';
    } else {
      return 'text';
    }
  }

  public handleCopySuccess() {
    this.alertService.success('Copied to Clipboard!');
  }
}

export const CopyToClipboardFieldComponent: angular.IComponentOptions = {
  controller: CopyToClipboardFieldController,
  controllerAs: 'ctrl',
  bindings: {
    inputContent: '<',
    inputIsEnabled: '<',
    inputIsPassword: '<',
  },
  template: `
    <div class="copy-to-clipboard-container">
      <input
        type="password"
        ng-if="ctrl.inputIsPassword"
        ng-class="{disabled: ctrl.isDisabled()}"
        class="form-control"
        ng-disabled="ctrl.isDisabled()"
        ng-value="ctrl.getDisplayContent()"
      />
      <input
        type="text"
        ng-if="!ctrl.inputIsPassword"
        ng-class="{disabled: ctrl.isDisabled()}"
        class="form-control"
        ng-disabled="ctrl.isDisabled()"
        ng-value="ctrl.getDisplayContent()"
      />
      <button
        copy-to-clipboard
        class="btn btn-optional-action"
        ng-show="ctrl.clipboardIsEnabled"
        clipboard-text="ctrl.getContent()"
        clipboard-success="ctrl.handleCopySuccess()"
        clipboard-enabled="ctrl.clipboardIsEnabled"
      >
        Copy
      </button>
    </div>
  `,
};
